import React, { useState, useEffect } from "react";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Avatar,
  Button,
  CircularProgress,
  TablePagination,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  ListItemIcon,
  TextField,
  ListItemText,
  Menu,
} from "@mui/material";
import ScreenShareOutlinedIcon from "@mui/icons-material/ScreenShareOutlined";
import { styled, useTheme } from "@mui/system";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../../AuthProvider";
import { GlobalStyles } from "@mui/system";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Divider,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
// import ExcelJS from "exceljs";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import FilePresentIcon from "@mui/icons-material/FilePresent";
import PresentToAllIcon from "@mui/icons-material/PresentToAll";
import SimCardDownloadIcon from "@mui/icons-material/SimCardDownload";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";

const Container = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  marginTop: theme.spacing(9),
  marginLeft: theme.spacing(3),
  marginRight: theme.spacing(3),
  borderRadius: theme.shape.borderRadius,
  backgroundColor: theme.palette.common.white,
}));

const Title = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  color: theme.palette.primary.main,
  fontSize: "1.5rem",
  textAlign: "center",
  fontWeight: "bold",
}));

const SignedInSection = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(4),
}));

const SignedInTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.primary.main,
  fontSize: "1.25rem",
}));

const EmployeePresentReports = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const [loader, setLoader] = useState(true);
  const [attendance, setAttendance] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const [open, setOpen] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [dateRange, setDateRange] = useState("today");

  const [openDialog, setOpenDialog] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const { oId,pId } = useAuth();
  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  // const { userId, oId } = useAuth();
  const [exportAnchorEl, setExportAnchorEl] = useState(null);
  const isExportMenuOpen = Boolean(exportAnchorEl);
  const [employees, setEmployees] = useState([]);

  const exportToExcel = () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Employees_Present_Reports");

    // Define headers
    const headers = [
      "S.No",
      "EmployeeId",
      "Employee Name",
      "Date",
      "Mobile No",
      "Status",
    ];

    // Add headers to the worksheet
    const headerRow = worksheet.addRow(headers);

    // Apply header styles (Blue background, white text, bold)
    headerRow.eachCell((cell) => {
      cell.font = { bold: true, color: { argb: "FFFFFF" } }; // White text
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "0070C0" }, // Blue background
      };
      cell.alignment = { horizontal: "center", vertical: "middle" };
    });

    // Add data rows
    attendance.forEach((employee, index) => {
      const status = ["Employee", "Admin", "Device"].includes(employee.status)
        ? "Present"
        : "Absent";

      const row = worksheet.addRow([
        index + 1,
        `${employee.employeeId}`,
        `${employee.firstName} ${employee.lastName}`,
        employee.date,
        employee.mobileNo,
        // employee.checkIn || "Not Punched In",
        // employee.checkOut || "Not Punched Out",
        // employee.checkinLocation || "N/A",
        status, // Corrected status logic
      ]);

      // Apply green text color to "Present" status
      const statusCell = row.getCell(8);
      if (status === "Present") {
        statusCell.font = { color: { argb: "00B050" } }; // Green text
      }
    });

    // Adjust column widths for better spacing
    worksheet.columns = [
      { width: 10 },
      { width: 20 },
      { width: 15 },
      { width: 15 },
      { width: 15 },
      { width: 30 },
      { width: 40 },
    ];

    // Save the file
    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      saveAs(blob, "Employees_Present_Reports.xlsx");
    });
  };

  const exportToPDF = () => {
    const doc = new jsPDF();

    // Title
    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);
    doc.text("Employees_Present_Reports", 10, 10);

    // Generated On Date
    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    doc.text(`Generated On: ${new Date().toLocaleDateString()}`, 10, 18);

    // Define table headers
    const tableColumn = [
      "S.No",
      "EmployeeId",
      "Employee Name",
      "Date",
    "Mobile No",
      "Status",
    ];

    // Define table rows
    const tableRows = attendance.map((employee, index) => [
      index + 1,
      `${employee.employeeId}`,
      `${employee.firstName} ${employee.lastName}`,
      employee.date,
       employee.mobileNo,
    //   employee.checkIn || "Not Punched in Yet",
    //   employee.checkOut || "Not Punched out Yet",
    //   employee.checkinLocation || "N/A",
      ["Employee", "Admin", "Device"].includes(employee.status)
        ? "Present"
        : "Absent",
    ]);

    // Generate table with margin
    doc.autoTable({
      head: [tableColumn],
      body: tableRows,
      startY: 25, // Ensure the table starts after the "Generated On" text
    });

    doc.save("Employees_Present_Reports.pdf");
  };

  const exportToJSON = () => {
    const jsonData = JSON.stringify(attendance, null, 2);
    const blob = new Blob([jsonData], { type: "application/json" });

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "Attendance_data.json";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleExportClick = (event) => {
    setExportAnchorEl(event.currentTarget);
  };
  const handleExportClose = () => {
    setExportAnchorEl(null);
  };
  const handleClose = () => {
    setExportAnchorEl(null);
  };

  const handleOpenModal = (employee) => {
    setSelectedEmployee(employee);
    setOpen(true);
  };

  const handleCloseModal = () => {
    setOpen(false);
    setSelectedEmployee(null);
  };

  const TableHeaderCell = styled(TableCell)(({ theme }) => ({
    color: "white",
    fontSize: "15px",
    textAlign: "center",
    fontWeight: "bold",
    border: "1px solid black",
  }));

  const getTodayDate = () => {
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, "0");
    const dd = String(today.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
  };

  const todayDate = getTodayDate();

  const handleDateRangeChange = (e) => {
    const selectedValue = e.target.value;
    setDateRange(selectedValue);

    if (selectedValue === "customDate") {
      setOpenDialog(true); // Open the dialog for custom date selection
    }
  };

  const handleGetButtonClick = () => {
    console.log("Start Date:", startDate, "End Date:", endDate);
    setOpenDialog(false);
    if (startDate && endDate) {
      setDateRange("customDate"); // Update state to trigger API call
      console.log("Date Range set to customDate");
    } else {
      console.error("Start Date or End Date is missing");
    }
  };

  const fetchAllAttendance = async () => {
    try {
      setLoader(true); // Start loading before fetching
      let endpoint = "";

      switch (dateRange) {
        case "today":
          endpoint = `${baseUrl}/api/attendance/employees/all/${todayDate}/${oId}/${pId}`;
          break;
        case "yesterday":
          endpoint = `${baseUrl}/api/attendance/employees/all/yesterday/${todayDate}/${oId}/${pId}`;
          break;
        case "lastWeek":
          endpoint = `${baseUrl}/api/attendance/employees/all/LastWeek/${todayDate}/${oId}/${pId}`;
          break;
        case "CurrentMonth":
          endpoint = `${baseUrl}/api/attendance/employees/all/currentMonth/${todayDate}/${oId}/${pId}`;
          break;
        case "lastMonth":
          endpoint = `${baseUrl}/api/attendance/employees/all/LastMonth/${todayDate}/${oId}/${pId}`;
          break;
        case "customDate":
          if (startDate && endDate) {
            endpoint = `${baseUrl}/api/attendance/employees/all/customDate/${startDate}/${endDate}/${oId}/${pId}`;
          } else {
            console.error("Custom date range is missing start or end date");
            return;
          }
          break;

        default:
          endpoint = `${baseUrl}/api/attendance/employees/all/${todayDate}/${oId}/${pId}`;
          break;
      }

      console.log("Endpoint:", endpoint);

      const response = await fetch(endpoint);
      const data = await response.json();

      console.log("Fetched Data:", data);

      const employeesWithImages = data.map((employee) => ({
        ...employee,
        checkInPic: employee.checkInPic
          ? `data:image/jpeg;base64,${employee.checkInPic}`
          : null,
        checkOutPic: employee.checkOutPic
          ? `data:image/jpeg;base64,${employee.checkOutPic}`
          : null,
      }));

      // Sort employeesWithImages so newly added rows appear on top
      const sortedAttendance = employeesWithImages.reverse();

      setAttendance(sortedAttendance);
    } catch (error) {
      console.error("Failed to fetch attendance", error);
    } finally {
      setLoader(false); // Hide loader
    }
  };

  useEffect(() => {
    // Fetch default attendance data on initial render
    if (!dateRange) {
      fetchAllAttendance();
    }
  }, []); // Run on initial render

  useEffect(() => {
    if (dateRange) {
      fetchAllAttendance();
    }
  }, [dateRange]);

  useEffect(() => {
    if (dateRange === "customDate" && startDate && endDate) {
      fetchAllAttendance();
    }
  }, [dateRange, startDate, endDate]);

  //for punch in location
  const truncateString = (str, num) => {
    if (typeof str !== "string") {
      return "Punch In Location Not Found";
    }
    if (str.length <= num) {
      return str;
    }
    return str.slice(0, num) + "...";
  };

  //for punch out location
  const truncateString1 = (str, num) => {
    if (typeof str !== "string") {
      return "Punch Out Location Not Found";
    }
    if (str.length <= num) {
      return str;
    }
    return str.slice(0, num) + "...";
  };

  const formatTimeFromArray = (timeArray) => {
    if (Array.isArray(timeArray) && timeArray.length === 2) {
      const [hours, minutes] = timeArray;
      if (hours != null && minutes != null) {
        const formattedHours = String(hours).padStart(2, "0");
        const formattedMinutes = String(minutes).padStart(2, "0");
        return `${formattedHours}:${formattedMinutes}`;
      }
    }
    // Return "N/A" if the timeArray is invalid or doesn't contain two elements
    return "N/A";
  };

  const handleClickOpen = (employee) => {
    // navigate(`/EmployeeAttendanceDetails/${employee.empId}`);
    navigate(`/EmployeeAttendanceDetails/${employee.empId}/${employee.employeeId}`);
  };

  return (
    <Container elevation={2} style={{ marginTop: "84px" }}>
      <Box display="flex" alignItems="center" sx={{ marginBottom: 2 }}>
        <IconButton onClick={() => navigate(-1)} sx={{ color: "#2e2a54" }}>
          <KeyboardBackspaceIcon fontSize="medium" />
        </IconButton>
        <Typography variant="h4" component="h3" sx={{ fontWeight: "bold" }}>
          Employees Present Reports
        </Typography>
      </Box>
      <SignedInSection>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 1,
          }}
        >
          <FormControl
            fullWidth
            variant="outlined"
            style={{ width: "280px", marginLeft: "15px" }}
            size="small"
          >
            <InputLabel>Date Range</InputLabel>
            <Select
              value={dateRange}
              onChange={handleDateRangeChange}
              label="Date Range"
            >
              <MenuItem value="today">Today</MenuItem>
              <MenuItem value="yesterday">Yesterday</MenuItem>
              <MenuItem value="lastWeek">Last Week</MenuItem>
              <MenuItem value="CurrentMonth">Current Month</MenuItem>
              <MenuItem value="lastMonth">Last Month</MenuItem>
              <MenuItem value="customDate">Custom Date</MenuItem>
            </Select>
          </FormControl>

          <Button
            variant="contained"
            onClick={handleExportClick}
            sx={{
              backgroundColor: "#3C3972",
              color: "#fff",
              "&:hover": { backgroundColor: "#3C3972" },

              marginBottom: 2,
            }}
            startIcon={<PresentToAllIcon />}
          >
            Export
          </Button>
          <Menu
            anchorEl={exportAnchorEl}
            open={isExportMenuOpen}
            onClose={handleExportClose}
            sx={{
              "& .MuiPaper-root": {
                backgroundColor: "#f5f5f5",
                borderRadius: "8px",
              },
            }}
          >
            <MenuItem
              onClick={exportToExcel}
              sx={{
                color: "#3f51b5",
                fontWeight: "bold",
                "&:hover": {
                  backgroundColor: "#e8f0fe",
                },
              }}
            >
              <ListItemIcon sx={{ color: "#00796b" }}>
                <SimCardDownloadIcon />
              </ListItemIcon>
              <ListItemText
                primary="Excel"
                sx={{ fontWeight: "bold", color: "#00796b" }}
              />
            </MenuItem>

            <MenuItem
              onClick={exportToPDF}
              sx={{
                color: "#d32f2f",
                fontWeight: "bold",
                "&:hover": {
                  backgroundColor: "#fdecea",
                },
              }}
            >
              <ListItemIcon sx={{ color: "#d32f2f" }}>
                <PictureAsPdfIcon />
              </ListItemIcon>
              <ListItemText
                primary="PDF"
                sx={{ fontWeight: "bold", color: "#d32f2f" }}
              />
            </MenuItem>

            {/* <MenuItem
              onClick={exportToJSON}
              sx={{
                color: "#388e3c",
                fontWeight: "bold",
                "&:hover": {
                  backgroundColor: "#e8f5e9",
                },
              }}
            >
              <ListItemIcon sx={{ color: "#6a1b9a" }}>
                <FilePresentIcon />
              </ListItemIcon>
              <ListItemText
                primary="JSON"
                sx={{ fontWeight: "bold", color: "#6a1b9a" }}
              />
            </MenuItem> */}
          </Menu>
        </Box>

        <Box>
          <CardContent>
            <GlobalStyles
              styles={{
                ".custom-sidebar-scrollbar": {
                  scrollbarWidth: "thin", // For Firefox
                  scrollbarColor: "grey #e0e0e0",
                },
                ".custom-sidebar-scrollbar::-webkit-scrollbar": {
                  width: "6px", // For WebKit-based browsers
                },
                ".custom-sidebar-scrollbar::-webkit-scrollbar-track": {
                  background: "#f1f1f1", // Track color
                },
                ".custom-sidebar-scrollbar::-webkit-scrollbar-thumb": {
                  backgroundColor: "grey", // Thumb color
                  borderRadius: "10px",
                },
                ".custom-sidebar-scrollbar::-webkit-scrollbar-thumb:hover": {
                  backgroundColor: "#555",
                },
              }}
            />

            <TableContainer
              component={Paper}
              style={{ maxHeight: "500px", overflowY: "auto" }}
              className="custom-sidebar-scrollbar"
            >
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    {[
                      "S.No",
                      // "Thumbnail",
                      "EmployeeId",
                      "Employee Name",
                      "Date",
                      "Mobile No",
                    //   "Punch In Time",
                    //   "Punch Out Time",
                    //   "Location",
                      "Status",
                     
                    ].map((header) => (
                      <TableCell
                        key={header}
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px",
                          textAlign: "center",
                          backgroundColor: "#fff9c4",
                          fontWeight: "Bold",
                          fontSize:'14px'
                        }}
                      >
                        {header}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>

                <TableBody>
                  {loader ? (
                    <TableRow>
                      <TableCell
                        colSpan={10}
                        style={{ textAlign: "center", padding: "20px" }}
                      >
                        <Box
                          display="flex"
                          flexDirection="column"
                          alignItems="center"
                        >
                          <CircularProgress />
                          <Typography variant="body2" sx={{ mt: 1 }}>
                            Loading Data...
                          </Typography>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ) : attendance.length === 0 ? (
                    <TableRow>
                      <TableCell
                        colSpan={10}
                        style={{ textAlign: "center", padding: "20px" }}
                      >
                        No data available
                      </TableCell>
                    </TableRow>
                  ) : (
                    attendance.map((employee, index) => (
                      <TableRow
                        key={employee.id}
                        sx={{
                          backgroundColor: "white",
                          transition: "background-color 0.3s",
                          "&:hover": { backgroundColor: "#f5f5f5" }, // Hover effect
                        }}
                      >
                        <TableCell
                          sx={{
                            borderRight: "1px solid #ddd",
                            padding: "2px",
                            textAlign: "center",
                            maxWidth: "50px",
                            minWidth: "50px",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {index + 1}
                        </TableCell>

                        {/* <TableCell
                          sx={{
                            borderRight: "1px solid #ddd",
                            textAlign: "center",
                            padding: "2px",
                            maxWidth: "50px",
                            minWidth: "50px",
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column", // Stack items vertically
                              alignItems: "center", // Center horizontally
                              justifyContent: "center", // Center vertically
                            }}
                          >
                            <Avatar
                              alt={employee.firstName}
                              src={employee.checkInPic}
                              sx={{
                                width: 30,
                                height: 30,
                                cursor: "pointer",
                                marginBottom: "5px",
                              }}
                              onClick={() => handleOpenModal(employee)}
                            />
                          </Box>
                        </TableCell> */}
                        <TableCell
                          sx={{
                            borderRight: "1px solid #ddd",
                            padding: "2px",
                            textAlign: "center",
                            maxWidth: "95px",
                            minWidth: "80px",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {employee.employeeId}
                        </TableCell>

                        <TableCell
                          sx={{
                            borderRight: "1px solid #ddd",
                            padding: "2px",
                            textAlign: "center",
                            maxWidth: "80px",
                            minWidth: "80px",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {employee.firstName} {employee.lastName}
                        </TableCell>

                        <TableCell
                          sx={{
                            borderRight: "1px solid #ddd",
                            padding: "2px",
                            textAlign: "center",

                            whiteSpace: "nowrap",
                          }}
                        >
                          {employee.date}
                        </TableCell>
                        <TableCell
                          sx={{
                            borderRight: "1px solid #ddd",
                            padding: "2px",
                            textAlign: "center",

                            whiteSpace: "nowrap",
                          }}
                        >
                          {employee.mobileNo}
                        </TableCell>

                        {/* <TableCell
                          sx={{
                            borderRight: "1px solid #ddd",
                            padding: "2px",
                            textAlign: "center",
                            maxWidth: "80px",
                            minWidth: "80px",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {employee.checkIn || "Not Punched in Yet"}
                        </TableCell>

                        <TableCell
                          sx={{
                            borderRight: "1px solid #ddd",
                            padding: "2px",
                            textAlign: "center",
                            maxWidth: "80px",
                            minWidth: "80px",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {employee.checkOut || "Not Punched out Yet"}
                        </TableCell>

                        <TableCell
                          style={{
                            color: "black",
                            textAlign: "center",
                            padding: 0, // Remove padding from the cell
                            verticalAlign: "top", // Ensure content is aligned to the top
                            maxWidth: "300px",
                          }}
                        >
                          <Box
                            display="flex"
                            flexDirection="column"
                            justifyContent="center"
                            alignItems="center"
                            width="100%" // Ensure the box takes up the full width
                            sx={{ borderRight: "1px solid #ddd" }}
                          >
                            {/* Check-in location 
                            <Box
                              style={{
                                width: "100%",
                                maxHeight: "45px", // Set a max height for the check-in section
                                overflowY: "auto", // Enable vertical scrolling if content overflows
                                padding: "8px 0",
                                borderRight: "1px solid #ddd",
                              }}
                            >
                              <Typography variant="body2" style={{}}>
                                {truncateString(employee.checkinLocation, 300)}
                              </Typography>
                            </Box>

                            {/* Divider Line 
                            <Box
                              component="hr"
                              style={{
                                width: "100%",
                                border: "none", // Remove default border
                                height: "1px", // Set line height to 1px for thinness
                                backgroundColor: "#ddd", // Set the line color to black
                                marginTop: "5px",
                              }}
                            />

                            {/* Check-out location 
                            <Box
                              style={{
                                width: "100%",
                                maxHeight: "50px", // Set a max height for the check-out section
                                overflowY: "auto", // Enable vertical scrolling if content overflows
                                padding: "8px 0",
                              }}
                            >
                              <Typography variant="body2" style={{}}>
                                {truncateString1(
                                  employee.checkoutLocation,
                                  300
                                )}
                              </Typography>
                            </Box>
                          </Box>
                        </TableCell> */}

                        <TableCell
                          sx={{
                            borderRight: "1px solid #ddd",
                            padding: "2px",
                            textAlign: "center",
                            maxWidth: "50px",
                            minWidth: "50px",
                            whiteSpace: "nowrap",
                            color: ["Employee", "Admin", "Device"].includes(
                              employee.status
                            )
                              ? "green"
                              : "red",
                            fontWeight: "bold",
                          }}
                        >
                          {["Employee", "Admin", "Device"].includes(
                            employee.status?.toString()
                          )
                            ? "Present"
                            : "Absent"}
                        </TableCell>

                        {/* <TableCell
                          sx={{
                            borderRight: "1px solid #ddd",
                            padding: "2px",
                            textAlign: "center",
                            maxWidth: "70px",
                            minWidth: "70px",
                            whiteSpace: "nowrap",
                            color: "green",
                            fontWeight: "bold",
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-around",
                            }}
                          >
                            <Button
                              type="button"
                              onClick={() => handleClickOpen(employee)}
                              sx={{
                                backgroundColor: "#3C3972",
                                color: "white",
                                fontSize: "0.6rem", // Reduces the font size
                                height: "25px", // Reduces the height
                                "&:hover": {
                                  backgroundColor: "#3C3972",
                                },
                              }}
                            >
                              Attendance
                            </Button>
                          </Box>
                        </TableCell> */}
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </CardContent>
        </Box>
      </SignedInSection>

      {/* Dialo for start date and end date selection  */}

      <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
        <DialogTitle sx={{ fontWeight: "bold", fontSize: "15px" }}>
          Select Custom Date Range
        </DialogTitle>
        <DialogContent>
          <div style={{ display: "flex", gap: "16px", marginTop: "10px" }}>
            <TextField
              label="Start Date"
              type="date"
              InputLabelProps={{ shrink: true }}
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              fullWidth
            />
            <TextField
              label="End Date"
              type="date"
              InputLabelProps={{ shrink: true }}
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              fullWidth
            />
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setOpenDialog(false)}
            variant="outlined"
            sx={{ width: "5px" }}
          >
            Cancel
          </Button>
          <Button
            onClick={() => {
              if (startDate && endDate) {
                handleGetButtonClick();
              } else {
                alert("Please select both Start Date and End Date.");
              }
            }}
            sx={{
              backgroundColor: "#3C3972",
              color: "#fff",
              "&:hover": { backgroundColor: "#3C3972" },
            }}
            variant="outlined"
          >
            Get
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={open} onClose={handleCloseModal} maxWidth="sm" fullWidth>
        <DialogTitle>
          {/* <strong style={{ fontSize: '20px' }}>Punch Details</strong> */}
          <strong style={{ fontSize: "20px" }}>
            Punch Details -
            <strong style={{ color: "#7e31ce" }}>
              {selectedEmployee?.firstName} {selectedEmployee?.lastName}{" "}
            </strong>
          </strong>
          <IconButton
            aria-label="close"
            onClick={handleCloseModal}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: "black", // Change the color to your desired value
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent>
          {selectedEmployee && (
            <Box gap={2}>
              {/* <Divider sx={{ width: "100%", marginY: 2 }} /> */}
              {/* Punch In Details */}
              <Card sx={{ maxWidth: 900 }}>
                <strong
                  style={{
                    fontSize: "15px",
                    padding: "20px",
                    color: "#0c8091",
                  }}
                >
                  Punch In Details
                </strong>
                <CardContent>
                  <Box
                    display="flex"
                    flexDirection="row"
                    alignItems="center"
                    gap={2}
                  >
                    <Avatar
                      alt="Punch In Photo"
                      src={selectedEmployee.checkInPic}
                      sx={{ width: 150, height: 150 }}
                    />
                    <Box>
                      <Typography
                        variant="h6"
                        style={{
                          fontWeight: "bold",
                          paddingLeft: "25px",
                          color: "#7e31ce",
                        }}
                      >
                        Punch In Time:{" "}
                      </Typography>
                      <Typography
                        variant="h6"
                        style={{
                          fontWeight: "bold",
                          paddingLeft: "25px",
                          color: "Green",
                          paddingTop: 5,
                        }}
                      >
                        {selectedEmployee.checkIn || "N/A"}
                      </Typography>
                      <Typography
                        variant="h6"
                        style={{
                          fontWeight: "bold",
                          paddingLeft: "25px",
                          color: "#7e31ce",
                        }}
                        mt={2}
                      >
                        Punch In Address:
                      </Typography>
                      <Typography
                        style={{ paddingLeft: "25px", paddingTop: 5 }}
                      >
                        {truncateString(selectedEmployee.checkinLocation, 300)}
                      </Typography>
                    </Box>
                  </Box>
                </CardContent>
              </Card>

              {/* Divider */}
              <Divider sx={{ width: "100%", marginY: 2 }} />

              {/* Punch Out Details */}
              <Card sx={{ maxWidth: 900, boxShadow: 1 }}>
                <strong
                  style={{
                    fontSize: "15px",
                    padding: "20px",
                    color: "#0c8091",
                  }}
                >
                  Punch Out Details
                </strong>
                <CardContent>
                  <Box
                    display="flex"
                    flexDirection="row"
                    alignItems="center"
                    gap={2}
                  >
                    <Avatar
                      alt="Punch Out Photo"
                      src={selectedEmployee.checkOutPic}
                      sx={{ width: 150, height: 150 }}
                    />
                    <Box>
                      <Typography
                        variant="h6"
                        style={{
                          fontWeight: "bold",
                          paddingLeft: "25px",
                          color: "#7e31ce",
                        }}
                      >
                        Punch Out Time:
                      </Typography>
                      <Typography
                        variant="h6"
                        style={{
                          fontWeight: "bold",
                          paddingLeft: "25px",
                          color: "Green",
                          paddingTop: 5,
                        }}
                      >
                        {selectedEmployee.checkOut || "N/A"}
                      </Typography>
                      <Typography
                        variant="h6"
                        style={{
                          fontWeight: "bold",
                          paddingLeft: "25px",
                          color: "#7e31ce",
                        }}
                        mt={2}
                      >
                        Punch Out Address:
                      </Typography>
                      <Typography
                        style={{ paddingLeft: "25px", paddingTop: 5 }}
                      >
                        {truncateString(selectedEmployee.checkoutLocation, 300)}
                      </Typography>
                    </Box>
                  </Box>
                </CardContent>
              </Card>
            </Box>
          )}
        </DialogContent>
      </Dialog>
    </Container>
  );
};

export default EmployeePresentReports;